import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appValidateZeroInput]'
})
export class ValidateZeroInputDirective {

  constructor() { }
  @HostListener('focus', ['$event'])
  onFocus(event: any) {
    if (event.target?.value == 0) {
      event.target.value = '';
    }
  }
}
